import React from 'react';
import { motion } from 'framer-motion';
import Button from './ui/Button';

const FinalCTA = () => {
  return (
    <section className="py-24 px-6 max-w-3xl mx-auto text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-dc-teal-deep mb-6">
          Choose the level that matches how close you want to get.
        </h2>
        <p className="text-lg text-dc-text/80 mb-10 max-w-2xl mx-auto">
          Start with the briefing to stay informed. Step into Build Your Network when you are ready for rooms, channels, directory presence, and quarterly guidance.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button variant="secondary" href="https://territory.digitalcowboy.io/checkout/?product_id=6405&product_type=membership">
            Get the Briefing
          </Button>
          <Button variant="primary" href="https://territory.digitalcowboy.io/checkout/?product_id=6406&product_type=membership">
            Build Your Network
          </Button>
        </div>
      </motion.div>
    </section>
  );
};

export default FinalCTA;